import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import FeedbackForm from '../../forms/feedback-form/feedback-form';

import style from './get-in-touch.module.scss';
// TODO: need to find correct type
const FormSubmitStatus = dynamic(() => import('../../forms/form-submit-status/form-submit-status'));

enum FORM_STATUS {
  active = 'active',
  success = 'success',
  error = 'error',
}

const COVER_REMOVE_TIMEOUT = 3000; // milliseconds

type GetInTouchComponentProps = {
  withSubtitle?: boolean;
};

const GetInTouchComponent = ({ withSubtitle = true }: GetInTouchComponentProps) => {
  const [currentFormStatus, setFormStatus] = useState(FORM_STATUS.active);
  const [isFormSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    const isFormSubmitted = [FORM_STATUS.success, FORM_STATUS.error].includes(currentFormStatus);
    if (isFormSubmitted) {
      setTimeout(() => {
        setFormStatus(FORM_STATUS.active);
      }, COVER_REMOVE_TIMEOUT);
    }
  }, [currentFormStatus]);

  const onSubmit = (success: boolean) => {
    if (success) {
      setFormStatus(FORM_STATUS.success);
    } else {
      setFormStatus(FORM_STATUS.error);
    }
  };

  return (
    <div className={style.container}>
      <div className={style.title}>Get in touch</div>
      {withSubtitle ? (
        <div className={style.subtitle}>
          Send us your comments, suggestions, questions, or feedback.
        </div>
      ) : (
        ''
      )}
      <FeedbackForm
        currentFormStatus={currentFormStatus}
        setFormSubmitted={(status: boolean) => setFormSubmitted(status)}
        isFormSubmitted={isFormSubmitted}
        onSubmit={(status: boolean) => onSubmit(status)}
      />
      {currentFormStatus !== FORM_STATUS.active && (
        <div className={style.status__wrapper}>
          <FormSubmitStatus
            status={currentFormStatus === FORM_STATUS.success ? 'success' : 'failure'}
          />
        </div>
      )}
    </div>
  );
};

export default GetInTouchComponent;
